<template>
  <div>
    <BaseTitle :title="$t(edit ? 'content.edit_announcement' : 'content.add_announcement')" :yearPeriode="titleData" />
    <v-row>
      <v-col cols="5" md="5">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('content.title')" :validator="$v.form.title">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.title"
                    :disabled="isEditable"
                    v-bind="attrs"
                    :label="$t('content.title')"
                    @input="$v.form.title.$touch()"
                    @blur="$v.form.title.$touch()"
                  />
                </template>
              </form-group>
              <form-group :name="$t('form.date')" :validator="$v.form.date" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-menu
                    ref="pickerDate"
                    v-model="pickerDate"
                    :close-on-content-click="false"
                    :return-value.sync="pickerDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template #activator="{ on, attrs:attrActivator }">
                      <v-text-field
                        v-model="form.date"
                        :label="$t('form.date')"
                        :disabled="isEditable"
                        readonly
                        v-bind="{ ...attrActivator, ...attrs }"
                        v-on="on"
                      >
                        <template #append>
                          <svg-icon icon="calendar" class="primary--text mr-3" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="form.date" :locale="$i18n.locale">
                      <v-spacer />
                      <v-btn text color="primary" @click="pickerDate = false">{{ $t('cancel') }}</v-btn>
                      <v-btn text color="primary" @click="$refs.pickerDate.save(form.date)">{{ $t('ok') }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </template>
              </form-group>
              <form-group :name="$t('form.time')" :validator="$v.form.time" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-menu
                    ref="pickerTime"
                    v-model="pickerTime"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="pickerTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs: attrActivator }">
                      <v-text-field
                        v-model="form.time"
                        :label="$t('form.time')"
                        :disabled="isEditable"
                        readonly
                        v-bind="{ ...attrActivator, ...attrs }"
                        v-on="on"
                      >
                        <template #append>
                          <svg-icon icon="clock" class="primary--text mr-3" />
                        </template>
                      </v-text-field>
                    </template>

                    <v-time-picker v-model="form.time" :locale="$i18n.locale" @click:minute="$refs.pickerTime.save(form.time)" />
                  </v-menu>
                </template>
              </form-group>
            </div>
          </v-card>
        </form>
      </v-col>
      <v-col cols="7" md="7">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-8">
              <div class="app-section-title mb-6">{{ $t('form.desc') }}</div>
              <form-group :name="$t('form.desc')" :validator="$v.form.description">
                <template slot-scope="{ attrs }">
                  <text-editor v-bind="attrs" v-model="form.description" @input="$v.form.description.$touch()" @blur="$v.form.description.$touch()" />
                </template>
              </form-group>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextEditor from '@/components/base/TextEditor.vue';
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'CreateEditAnnouncement',
  components: {
    BaseTitle,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        title: { required },
        date: { required },
        time: { required },
        description: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      tokenBearer: 'Auth/token',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    form: {
      title: '',
      description: '',
      date: '',
      time: ''
    },
    pickerDate: false,
    pickerTime: false,
    loadingButton: false,
    dataClass: '',
    loading: false,
    edit: false,
    titleData: ''
  }),
  methods: {
    getData() {
      this.$store.dispatch('Announcement/fetchDetailId', this.$route.params.id).then(ras => {
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
      });
    },
    getDataGradeId() {
      this.loading = true;
      this.$store
        .dispatch('QuizTeacher/fetchListGradeId', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          this.form.gradeId = res.gradeId;
        })
        .finally(() => (this.loading = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    submit() {
      if (!this.form.description) {
        this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.alert_form_desc') });
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      const input = {
        title: this.form.title,
        description: this.form.description,
        date: this.form.date,
        time: this.form.time,
        classroomId: this.$route.params.classId,
        courseId: this.$route.params.courseId,
        classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
      };

      this.loading = true;
      const payload = { ...(this.edit ? { id: this.$route.params.id } : null), ...input };

      this.$store
        .dispatch(`Announcement/${this.edit ? 'update' : 'save'}`, payload)
        .then(() =>
          this.$router.push({
            name:
              this.edit && !this.$route.params.classSectionId
                ? 'AnnouncementTeacherUpdateSuccess'
                : !this.edit && !this.$route.params.classSectionId
                ? 'AnnouncementTeacherSuccess'
                : this.edit && this.$route.params.classSectionId
                ? 'AnnouncementSectionTeacherUpdateSuccess'
                : 'AnnouncementSectionTeacherSuccess'
          })
        )
        .finally(() => (this.loading = false));
    },
    back() {
      if (this.isClass && !this.isStudent) {
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'AnnouncementIndexClass' });
        } else {
          this.$router.push({ name: 'AnnouncementSectionIndexClass' });
        }
      } else if (this.isClass && this.isStudent) {
        this.$router.push({ name: 'AnnouncementStudentIndexClass' });
      } else {
        this.$router.push({ name: 'AnnouncementIndex' });
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getData();
      this.edit = true;
    }
    if (this.isClass) {
      this.getDataGradeId();
      this.getDataClass();
    } else {
      this.getClassLevel();
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
</style>
